export default __webpack_public_path__ + "fe48bf7c1d10f380139c0b05ad38e7a2.png";